module.exports = __webpack_public_path__ + "img/cover.af3b4cf2.jpg";